import script from "./AlertDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./AlertDialog.vue?vue&type=script&setup=true&lang=js"

import "./AlertDialog.vue?vue&type=style&index=0&id=00cca204&lang=scss&scoped=true"
script.__scopeId = "data-v-00cca204"

export default script